module.exports = __webpack_public_path__ + "static/media/guaranteeBanner.43f0ecbe.jpg";